import {
	ApolloClient, ApolloLink, InMemoryCache,
} from '@apollo/client';
import { RetryLink } from '@apollo/client/link/retry';
import { createUploadLink } from 'apollo-upload-client';
import createMockLink, { mocks } from 'auth/lib/apolloLinks/mock';
import { getTokenRefreshLink } from 'auth/lib/apolloLinks/errors';
import { authLink } from 'auth/lib/apolloLinks/auth';

const retryLink = new RetryLink({
	attempts: {
		max:     0,
		retryIf: () => false, // Never retry after failure
	},
});

export type ApolloClientOptions = {
	graphQLUri: string;
	refreshToken: () => Promise<void>;
	onExpired?: () => void;
};

const getApolloClient = ({
	graphQLUri,
	refreshToken,
}: ApolloClientOptions) => new ApolloClient({
	uri:   graphQLUri,
	cache: new InMemoryCache(),
	link:  ApolloLink.split(
		// @ts-ignore
		(operation) => operation.operationName && operation.operationName.startsWith('authGraph'),
		ApolloLink.from([
			retryLink,
			getTokenRefreshLink(refreshToken),
			authLink,
			createUploadLink({
				uri: `${import.meta.env.VITE_API_PATH}/graphql/gn_ga`,
			}),
		]),
		ApolloLink.split(
			(operation) => mocks.some(([name]) => name === operation.operationName),
			createMockLink(),
			ApolloLink.from([
				retryLink,
				getTokenRefreshLink(refreshToken),
				authLink,
				createUploadLink({
					uri: graphQLUri,
				}),
			]),
		),
	),
});

export default getApolloClient;
